import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import * as pluginAnnotation from 'chartjs-plugin-annotation';


@Component({
  selector: 'app-live-tracking-chart',
  templateUrl: './live-tracking-chart.component.html',
  styleUrls: ['./live-tracking-chart.component.css']
})
export class LiveTrackingChartComponent implements OnInit {

  @ViewChild(BaseChartDirective, { static: false }) chart: BaseChartDirective;
  @Input() eventdata: any;
  panelOpenState: boolean = false;


  constructor() { }


  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(this.data);
    // console.log(Array.isArray(this.data));
    // console.log(changes);
    if (Array.isArray(this.eventdata) == true ){
      for (let i = 0; i < this.eventdata.length; i++) {
        this.loadChartData(this.eventdata[i]);
      }
      this.loadingChartAnnotations(this.eventdata[0]); 
    }
    else{
      this.loadChartData(this.eventdata);
      console.log(typeof this.eventdata);
    }
  }

  //live tracking line charts
  loadChartData(data) {
    const _lineChartDataTemp = this.chartDatasets[0];
    _lineChartDataTemp.data.push(data.temperature);
    const _lineChartDataHumd = this.chartDatasets[1];
    _lineChartDataHumd.data.push(data.humidity);
    const _lineChartLabels = this.chartLabels;
    _lineChartLabels.push(data.logTime);
  }
  loadingChartAnnotations(data) {
    this.chartOptions.annotation.annotations[0].label.content = "Max hum" + " " + data.maxHumidity;
    this.chartOptions.annotation.annotations[0].value = data.maxHumidity;

    this.chartOptions.annotation.annotations[1].label.content = "Min hum" + " " + data.minHumidity;
    this.chartOptions.annotation.annotations[1].value = data.minHumidity;

    this.chartOptions.annotation.annotations[2].label.content = "Max temp" + " " + data.maxTemperature;
    this.chartOptions.annotation.annotations[2].value = data.maxTemperature;

    this.chartOptions.annotation.annotations[3].label.content = "Min temp" + " " + data.minTemperature;
    this.chartOptions.annotation.annotations[3].value = data.minTemperature;

    this.updateChart();
  }
  //updating chart ..
  private updateChart() {
    this.chart.ngOnChanges({});
  }

  public chartLabels: string[] = [];
  public barChartPlugins = [pluginAnnotation];
  public chartType: string = 'line';
  public ChartLegend: boolean = true;
  public chartColors: Array<any> = [
    {
      backgroundColor: 'rgba(105,159,177,0.2)',
      borderColor: 'rgba(105,159,177,1)',
      pointBackgroundColor: 'rgba(105,159,177,1)',
      pointBorderColor: '#fafafa',
      pointHoverBackgroundColor: '#fafafa',
      pointHoverBorderColor: 'rgba(105,159,177)',
      fill: false
    },
    {
      backgroundColor: 'rgba(77,20,96,0.3)',
      borderColor: 'rgba(77,20,96,1)',
      pointBackgroundColor: 'rgba(77,20,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,20,96,1)',
      fill: false
    }
  ];
  public chartDatasets: any[] = [
    { data: [], label: 'Temp(deg celisus)' },
    { data: [], label: 'Humidity(deg celisus)' },
  ];
  labelMFL: Array<any> = [{ data: this.chartDatasets, label: 'updating values' }];
  public chartOptions: any = {
    responsive: true,
    scales: {
      yAxes: [
        {
          stacked: true,
          display: true,
          suggestedMin: 0,
          ticks: {
            min: 0,
            stepSize: 10
          }
        }
      ],
      xAxes: [{
        type: 'time',
        time: {
          unit: 'hour',
          displayFormats: {
            'hour': 'HH:mm',
            'day': 'MMM D'
          },
        },
        ticks: {
          major: {
            enabled: true,
            fontColor: 'red',
          },
        },
      }],
    },
    annotation: {
      annotations: [
        {
          type: 'line',
          mode: 'horizontal',
          scaleID: 'y-axis-0',
          value: 0,
          borderColor: 'rgba(77,20,96,1)',
          borderWidth: 2,
          borderDash: [2, 2],
          label: {
            enabled: true,
            fontColor: 'orange',
            content: ' '
          }
        },

        {
          type: 'line',
          mode: 'horizontal',
          scaleID: 'y-axis-0',
          value: 0,
          borderColor: 'rgba(77,20,96,1)',
          borderWidth: 2,
          borderDash: [2, 2],
          label: {
            enabled: true,
            fontColor: 'orange',
            content: ' '
          }
        },
        {
          type: 'line',
          mode: 'horizontal',
          scaleID: 'y-axis-0',
          value: 0,
          borderColor: 'rgba(105,159,177,1)',
          borderWidth: 2,
          borderDash: [2, 2],
          label: {
            enabled: true,
            fontColor: 'rgba(105,159,177,1)',
            content: ' '
          }
        },
        {
          type: 'line',
          mode: 'horizontal',
          scaleID: 'y-axis-0',
          value: 0,
          borderColor: 'rgba(105,159,177,1)',
          borderWidth: 2,
          borderDash: [2, 2],
          label: {
            enabled: true,
            fontColor: 'rgba(105,159,177,1)',
            content: ' '
          }
        },
      ],
    },
  };

  public chartClicked(e: any): void {
    console.log(e);
  }
  public chartHovered(e: any): void {
    console.log(e);
  }

}
